<div class="lum-c-job-output-dialog">
  <div class="lum-c-job-output-dialog__header">
    <h2 class="lum-c-job-output-dialog__title">Job Output</h2>
    <button 
      mat-icon-button 
      class="lum-c-job-output-dialog__close-btn"
      (click)="closeDialog()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="lum-c-job-output-dialog__content">
    <div class="lum-c-job-output-dialog__job-info">
      <div class="lum-c-job-output-dialog__job-detail">
        <strong>Job:</strong> {{ data.job.label }}
      </div>
      <div class="lum-c-job-output-dialog__job-detail">
        <strong>Status:</strong> 
        <span 
          class="lum-c-job-output-dialog__status-badge"
          [ngClass]="'lum-c-job-output-dialog__status-badge--' + data.job.status"
        >
          {{ data.job.status }}
        </span>
      </div>
      <div class="lum-c-job-output-dialog__job-detail">
        <strong>Created:</strong> {{ data.job.createdAt | date: 'medium' }}
      </div>
    </div>

    <div class="lum-c-job-output-dialog__output-section">
      <div class="lum-c-job-output-dialog__output-header">
        <h3>Output</h3>
        <button 
          mat-button 
          color="primary"
          (click)="copyToClipboard()"
        >
          <mat-icon>content_copy</mat-icon>
          Copy
        </button>
      </div>
      
      <div class="lum-c-job-output-dialog__output-container">
        <pre class="lum-c-job-output-dialog__output-text">{{ formattedOutput }}</pre>
      </div>
    </div>
  </div>

  <div class="lum-c-job-output-dialog__actions">
    <button 
      mat-button 
      (click)="closeDialog()"
    >
      Close
    </button>
  </div>
</div> 